const sectionsData = {
  sections: [
    {
      title: "Delivery / Collection",
      subtitles: [
        {
          subtitle: "What time do we deliver until?",
          paragraph:
            "All Bradford deliveries will be made between 10am and 5pm. We are not able to state or prioritise any delivery times unless a guaranteed time slot is added at checkout. Nationwide deliveries are made between 9am and 6pm with our courier service and full tracking will be provided for this.",
        },
        {
          subtitle: "Do you deliver across UK?",
          paragraph:
            "Yes we do! We offer same day, next day and nominated day delivery for all orders placed within the Bradford area. Next day and nominated day delivery is available for all other nationwide orders. Next day orders should be placed before 1pm. We use our trusted courier service DPD for all of our orders. Nationwide delivery is for any postcode based within the UK.",
        },
        {
          subtitle: "Can I collect my order?",
          paragraph:
            "Yes — we offer same-day, next-day, and nominated-day collection from our Fleure retail store in Bradford, West Yorkshire. Collections are available daily between 9am and 7pm. Please select your preferred collection date and time slot at checkout. Orders should be collected at the selected time. If you need to change your collection time, please notify us in advance. Full collection details will be included in your confirmation email after checkout. Please select your preferred collection date and time at checkout. Orders should be collected at the chosen time. If you need to make changes, please contact us in advance. Full details will be included in your confirmation email.",
        },
      ],
    },
    {
      title: "Flowers",
      subtitles: [
        {
          subtitle: "Can I see a picture of my bouquet?",
          paragraph:
            "Unfortunately, we cannot provide each order with an image. The product options on our website are for display purposes only, and you can expect to receive an equally stunning bouquet using the colour scheme selected.",
        },
        {
          subtitle: "How do I care for my bouquet?",
          paragraph:
            "Cutting the stems and refreshing water daily is our key! However, a full care guide will be provided with each of your bouquets so you can get maximum vase life from your flower stems.",
        },
        {
          subtitle: "How long do your flowers last?",
          paragraph:
            "With flowers being a perishable good, this is hard to give a precise answer. Some stems can last up to 3 weeks, even a month if looked after properly. However, we will only guarantee our flowers for 3 days after delivery.",
        },
        {
          subtitle: "Can I add a gift message to my order?",
          paragraph:
            "Of course! Flowers speak louder with words. You can add a card message onto each product, or if you have missed this, you can also add a gift message at checkout!",
        },
      ],
    },
    {
      title: "Cancellations / Amendments",
      subtitles: [
        {
          subtitle: "Can I cancel my order?",
          paragraph:
            "Unfortunately, we cannot cancel any orders once placed. If you need to change or amend any order details, please get in touch, and we will try our best to accommodate these amendments.",
        },
        {
          subtitle: "Can I change my delivery address?",
          paragraph:
            "In most cases, if given notice with enough time, we should be able to change your delivery address. Please get in touch, and we will try our best to help.",
        },
        {
          subtitle: "What if I wrote my card message wrong?",
          paragraph:
            "Please get in touch as early as you notice the mistake, and we will always do our best to help make changes to your card message.",
        },
      ],
    },
    {
      title: "Shipping Policy",
      subtitles: [
        {
          subtitle: "Company Details",
          paragraph:
            "Company Name: Fleur\u00e9 UK Ltd, Address: 40 Hollybank Road BD7 4QP, through the small gate down the driveway, Phone: 07585626475.",
        },
        {
          subtitle: "Delivery Times",
          paragraph:
            "Monday to Saturday: 9:00 AM \u2013 5:00 PM. Sunday: unavailable for nationwide delivery, but local deliveries within Bradford are available.",
        },
        {
          subtitle: "Studio Collection Times",
          paragraph:
            "Monday-Sunday 11am - 7pm. Location: Fleur\u00e9, 40 Hollybank Road, Bradford BD7 4QP, through small gate down the drive.",
        },
        {
          subtitle: "Shipping Details",
          paragraph:
            "Delivery charges will be calculated at checkout. If the recipient is unavailable, the item may be left with a neighbour or in a secure location. Non-delivery items will be returned to the studio.",
        },
      ],
    },
    {
      title: "Returns and Refunds",
      subtitles: [
        {
          subtitle: "Perishable Goods",
          paragraph:
            "Due to the perishable nature of our products, refunds or replacements are only offered for issues reported within 1 working day of delivery or the intended delivery date. For quality-related complaints, we require photographic evidence.",
        },
        {
          subtitle: "How to Request a Refund or Return",
          paragraph:
            "Contact us via phone (07585626475) or email with your order details, reason for return/refund, and any supporting evidence (e.g., photos).",
        },
        {
          subtitle: "Exclusions",
          paragraph:
            "Refunds and returns do not apply to custom or bespoke orders unless the product is faulty. We cannot accept responsibility for issues arising from incorrect care after delivery.",
        },
      ],
    },
    {
      title: "Cancellation Policy",
      subtitles: [
        {
          subtitle: "Order Cancellations",
          paragraph:
            "Orders cannot be cancelled once ordered. If you require any amendments, please get in contact and we will try our best to accommodate these.",
        },
      ],
    },
    {
      title: "Privacy Policy",
      subtitles: [
        {
          subtitle: "Personal Data",
          paragraph:
            "This Privacy and Cookies Policy is issued by Fleuré UK Ltd., registered in England and Wales, located at 559–561 Great Horton Road, Bradford, BD7 4EF. Fleuré operates as a retail florist and café. Personal data may be collected when customers place floral orders, café orders, table bookings, or contact us via the website or in store.Personal data is used solely for order processing, customer communication, and service improvement, in accordance with UK data protection laws.",
        },
        {
          subtitle: "Data Collection",
          paragraph:
            "We collect the following information when you place an order or interact with our website: Name, Address, Contact Number, Email Address.",
        },
        {
          subtitle: "Marketing Communications",
          paragraph:
            "By providing your contact information, you may opt in to receive marketing communications. Consent can be withdrawn at any time.",
        },
        {
          subtitle: "Data Security",
          paragraph:
            "Your personal data is stored securely. Payment details are processed securely and are not stored by us.",
        },
        {
          subtitle: "Cookies",
          paragraph:
            "Cookies are used to improve website functionality and security. You may disable cookies, but it may affect website functionality.",
        },
        {
          subtitle: "Sharing and Third Parties",
          paragraph:
            "We do not sell, trade, or share your personal information with third parties for marketing purposes. Data may be shared with trusted third parties solely to fulfil your order (e.g., delivery services) or for legal compliance.",
        },
        {
          subtitle: "Your Rights",
          paragraph:
            "You have rights to access, correct, delete, and transfer your data. You can opt out of direct marketing at any time.",
        },
        {
          subtitle: "Updates to This Policy",
          paragraph:
            "We may update this policy periodically to reflect changes in regulations or business practices. The latest version will always be available on our website.",
        },
      ],
    },
    {
      title: "Disclaimer",
      subtitles: [
        {
          subtitle: "Service Availability",
          paragraph:
            "We strive to ensure that our website and services are operational and error-free. However, we cannot guarantee uninterrupted access and accept no liability for service interruptions caused by events beyond our control (e.g., technical failures, acts of God). Force Majeure We are not liable for delays or failures in fulfilling our obligations due to circumstances beyond our reasonable control, including but not limited to severe weather, strikes, or supply chain disruptions.",
        },
      ],
    },
  ],
};

export default sectionsData;
